var jwtDecode = require('jwt-decode');

const state = {
  token: ''
}

const mutations = {
  setAuthToken (state, token) {
    state.token = token
  }
}

const getters = {
  getAuthToken: state => {
    return state.token
  },
  decodedToken: state => {
    try {
      return jwtDecode(state.token)
    } catch (e) {
      console.log(e)
      return undefined
    }
  },
  isTokenExpired: (state, getters) => {
    if (!getters.decodedToken) return true
    var currentTime = Date.now().valueOf() / 1000
    if (getters.decodedToken.exp < currentTime) {
      return true
    }
    return false
  }
}

export default { // Can also contain getters and actions
  state,
  mutations,
  getters
}
